<template>
  <div class="about">
    <h1 class="this"> Just A site to better the world.</h1>
  </div>
</template>
<style>
.this {
  font-weight:normal;
}
</style>